// extracted by mini-css-extract-plugin
module.exports = {"loading-indicator":"loading-m__loading-indicator__1ZTJW"};